import { connect } from 'react-redux'
import FieldCheckboxSet from './FieldCheckboxSet'
import { formatHasColumns } from '../../export/exportStompunkter'

const mapStateToProps = (state, ownProps) => ({
	visible: formatHasColumns(state.exportSettings.format)
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(FieldCheckboxSet)



// WEBPACK FOOTER //
// ./src/components/Export/FieldCheckboxSetContainer.js